var exports = {
  "k": "MessageCharacterCounter.module__container___X0NlZ2",
};

module.exports = exports;
